module.exports = { id: "display", url: "/build/app/img/symbols.svg#display", viewBox: "", toString: function() { return this.url; } };